var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 0c3.452 0 6.25 2.768 6.25 6.182v21.636C12.5 31.232 9.702 34 6.25 34S0 31.232 0 27.818V6.182C0 2.768 2.798 0 6.25 0Zm37.5 0C47.202 0 50 2.768 50 6.182v21.636C50 31.232 47.202 34 43.75 34s-6.25-2.768-6.25-6.182V6.182C37.5 2.768 40.298 0 43.75 0Z",
    fill: "url(#icon-eye_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-eye_svg__a",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2F3238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3238",
    stopOpacity: 0.6
  })))));
};
export default SvgIconEye;